import { Injectable } from '@angular/core';
import { SSOInformation } from '../security/sso/sso-information.model';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase PlatformEndpoint, servicio de autenticación de la aplicación
 *
 * *Defines PlatformEndpoint, App auth service*
 *
 * @type {class}
 */
export class PlatformCommunicatorAuthService {

  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @function sessionStorage.removeItem
   */
  constructor() {
    sessionStorage.removeItem('token-api');
    sessionStorage.removeItem('session-id');
    sessionStorage.removeItem('token-otp-jemelli');
  }

  /**
   * Función para guardar la información SSO en sessionStorage
   *
   * *Function to save SSO information in sessionStorage*
   *
   * @type {function}
   * @param {SSOInformation} ssoInformation
   */
  saveSSOInformation(ssoInformation: SSOInformation): void {
    sessionStorage.setItem('token-api', JSON.stringify(ssoInformation));
  }

  /**
   * Función para obtener la información SSO desde sessionStorage
   *
   * *Function to obtain SSO information from sessionStorage*
   *
   * @type {function}
   */
  getSSOInformation(): SSOInformation {
    return JSON.parse(sessionStorage.getItem('token-api') || '{}');
  }

  /**
   * Función para guardar la sesion en sessionStorage
   *
   * *Function to save session information in sessionStorage*
   *
   * @type {function}
   * @param {SSOInformation} ssoInformation
   */
  saveSessionId(sessionId: string): void {
    sessionStorage.setItem('session-id', sessionId);
  }

  /**
   * Función para obtener la session desde sessionStorage
   *
   * *Function to obtain session information from sessionStorage*
   *
   * @type {function}
   */
  getSessionId(): string {
    return sessionStorage.getItem('session-id') || '';
  }

  /**
   * Función para guardar la sesion en sessionStorage
   *
   * *Function to save session information in sessionStorage*
   *
   * @type {function}
   * @param {SSOInformation} ssoInformation
   */
  saveSessionClientProduct(clientProduct: string): void {
    sessionStorage.setItem('client-product', clientProduct);
  }
  /**
   * Función para obtener la session desde sessionStorage
   *
   * *Function to obtain session information from sessionStorage*
   *
   * @type {function}
   */
  clientProduct(): string {
    return sessionStorage.getItem('client-product') || '';
  }

  saveSSOTokenForOTP(ssoInformation: SSOInformation): void {
    sessionStorage.setItem('token-otp-jemelli', JSON.stringify(ssoInformation));
  }

  /**
   * Función para obtener la información SSO desde sessionStorage
   *
   * *Function to obtain SSO information from sessionStorage*
   *
   * @type {function}
   */
  getSSOTokenForOTP(): SSOInformation {
    return JSON.parse(sessionStorage.getItem('token-otp-jemelli') || '{}');
  }
}
